import { Box, Flex, Icon, Input, InputGroup } from "@chakra-ui/react";
import { HiOutlineMagnifyingGlass } from "react-icons/hi2";
import { useEffect, useRef, useState } from "react";
import FilterSelect from "./FilterSelect";
import {
    COMPANY_STATUS_OPTIONS,
    ROLE_OPTIONS,
    SORT_LABELS,
    SORT_OPTIONS,
    USER_STATUS_OPTIONS,
} from "../clientsQuery";

const sortItems = SORT_OPTIONS.map((value) => ({ value, label: SORT_LABELS[value] }));

/** Search box (debounced) + company-status / user-status / role / sort filters. */
const ClientsToolbar = ({ query, onChange }) => {
    const [searchDraft, setSearchDraft] = useState(query.search);
    const committedSearch = useRef(query.search);
    const onChangeRef = useRef(onChange);
    onChangeRef.current = onChange;

    // keep the box in sync when the query is restored from the URL (e.g. Back navigation)
    useEffect(() => {
        committedSearch.current = query.search;
        setSearchDraft(query.search);
    }, [query.search]);

    // debounce typing -> query, without re-running on unrelated query changes
    useEffect(() => {
        if (searchDraft === committedSearch.current) return undefined;
        const id = setTimeout(() => {
            committedSearch.current = searchDraft.trim();
            onChangeRef.current({ search: searchDraft.trim() });
        }, 300);
        return () => clearTimeout(id);
    }, [searchDraft]);

    return (
        <Flex w="full" gap={3} direction={{ base: "column", md: "row" }} align={{ base: "stretch", md: "center" }} flexWrap="wrap">
            <Box flex="1" minW={{ base: "full", md: "260px" }}>
                <InputGroup startElement={<Icon color="text.grey"><HiOutlineMagnifyingGlass /></Icon>}>
                    <Input
                        variant="primary"
                        fontSize={16}
                        py={5}
                        placeholder="Search by company, NIP, user or email…"
                        value={searchDraft}
                        onChange={(e) => setSearchDraft(e.target.value)}
                    />
                </InputGroup>
            </Box>
            <Flex gap={2} flexWrap="wrap">
                <FilterSelect
                    label="Company"
                    value={query.companyStatus}
                    options={COMPANY_STATUS_OPTIONS}
                    onChange={(v) => onChange({ companyStatus: v })}
                />
                <FilterSelect
                    label="User"
                    value={query.userStatus}
                    options={USER_STATUS_OPTIONS}
                    onChange={(v) => onChange({ userStatus: v })}
                />
                <FilterSelect
                    label="Role"
                    value={query.role}
                    options={ROLE_OPTIONS}
                    onChange={(v) => onChange({ role: v })}
                />
                <FilterSelect
                    label="Sort"
                    value={query.sort}
                    options={sortItems}
                    onChange={(v) => onChange({ sort: v })}
                    width="210px"
                />
            </Flex>
        </Flex>
    );
};

export default ClientsToolbar;
